import { render, staticRenderFns } from "./SiteStats.vue?vue&type=template&id=f0da3b06&scoped=true"
import script from "./SiteStats.vue?vue&type=script&lang=js"
export * from "./SiteStats.vue?vue&type=script&lang=js"
import style0 from "./SiteStats.vue?vue&type=style&index=0&id=f0da3b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0da3b06",
  null
  
)

export default component.exports